import { useDispatch, useSelector } from "react-redux";
import { setClient, setSkipClientSelection } from "../../../../redux/features/jobCreateSlice";
import { ClientsTable } from "../../../clients/clientsTable";

type SelectClientStepProps = {
  isUpdateJob?: boolean;
  jobId?: string | number | null;
  onUpdated?: () => void | Promise<void>;
};

export function SelectClientStep({ isUpdateJob, jobId, onUpdated }: SelectClientStepProps) {
  const selectedClient = useSelector((state: any) => state.jobCreateStepper.client);

  const skipClientSelection = useSelector((state: any) => state.jobCreateStepper.skipClientSelection);

  const dispatch = useDispatch();

  return (
    <ClientsTable
      allowSelected
      selectedClient={selectedClient}
      onSelectClientAndCoverage={(client) => {
        dispatch(setClient(client));
      }}
      skipClientSelection={skipClientSelection}
      onSkipClientSelection={(checked) => {
        dispatch(setSkipClientSelection(checked));
      }}
      disableRecordClickable
      isUpdateJob={isUpdateJob}
      jobId={jobId}
      onUpdated={onUpdated}
    />
  );
}
